import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const SubscriptionsTable = ({
  subscriptions,
  onCancel,
  isLoading,
  formatCurrency,
  formatDateTime,
  statusColor,
}) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Subscriptions</Heading>
          <Text fontSize="sm" color="gray.500">
            {subscriptions.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : subscriptions.length === 0 ? (
          <EmptyState title="No subscriptions yet" description="Create a plan and subscription to see data here." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Customer</Th>
                  <Th>Plan</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Period End</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {subscriptions.map((subscription) => (
                  <Tr key={subscription.id}>
                    <Td>{subscription.customer?.email}</Td>
                    <Td>{subscription.plan?.name}</Td>
                    <Td isNumeric>
                      {formatCurrency(subscription.plan?.amount, subscription.plan?.currency)}
                    </Td>
                    <Td>
                      <Badge colorScheme={statusColor(subscription.status)}>{subscription.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(subscription.currentPeriodEnd)}</Td>
                    <Td>
                      <Button
                        size="xs"
                        variant="outline"
                        colorScheme="orange"
                        isDisabled={subscription.status !== "ACTIVE"}
                        onClick={() => onCancel(subscription)}
                      >
                        Cancel
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default SubscriptionsTable;
